import { laisPath } from '../laisRouteHelpers';
import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';

export const contractRoute = {
  path: laisPath('contrato'),
  component: RentFlowsIndex,
  meta: { referenceAuthenticated: true },
};

export default contractRoute;
